export const booleanTranslate = (data, translation = { true: 'Yes', false: 'No' }) => {
    const translated = {};
    for (const [key, value] of Object.entries(data)) {
        translated[key] =
            value === 'true' || value === 'false' ? translation[value.toString()] : value;
    }
    return translated;
};

export const convertBool = (value) => {
    return value === 'true' ? 'Yes' : value === 'false' ? 'No' : value;
};
